import { PageTransitionLinkMain } from '@components/PageTransitionLink/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { transparentize } from 'polished'
import styled from 'styled-components'

export const RegulatoryNewsMain = styled.div``

export const RegulatoryNewsItem = styled.div`
  position: relative;
  padding-right: 3.2rem;
  border-bottom: 0.1rem solid ${transparentize(0.8, colors.charcoal)};

  &:first-child {
    border-top: 0.1rem solid ${transparentize(0.8, colors.charcoal)};
  }

  ${PageTransitionLinkMain} {
    text-decoration: none;
  }
`

export const RegulatoryNewsItemIcon = styled.div`
  position: absolute;
  right: 0;
  ${clamp('bottom', 28, 55)}
  width: 2rem;
`

export const RegulatoryNewsLink = styled.a`
  text-decoration: none;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    height: auto;
    z-index: 1;
  }
`
